// M21: 概率 - Probability
// 系統化數據結構，準備 Supabase 後端遷移

export const M21_MODULE_INFO = {
  moduleId: 'M21',
  title: '概率',
  titleEn: 'Probability',
  description: '學習概率的基本理論和應用',
  totalTopics: 5,
  estimatedTime: '8-10小時',
  difficulty: 'intermediate',
  prerequisites: ['M01', 'M20'],
  learningObjectives: [
    '理解概率的基本概念',
    '掌握條件概率的計算',
    '應用概率解決實際問題',
    '理解隨機變量分布',
    '掌握概率的組合應用'
  ]
};

export const M21_TOPICS = [
  {
    id: 'M21_01',
    name: "基本概率",
    description: "樣本空間、事件、概率的基本定義和計算",
    order: 1,
    subTopics: [
      "樣本空間的概念",
      "事件的定義和運算",
      "古典概率模型",
      "幾何概率模型",
      "概率的基本性質"
    ]
  },
  {
    id: 'M21_02',
    name: "條件概率",
    description: "在已知某事件發生的條件下，另一事件發生的概率",
    order: 2,
    subTopics: [
      "條件概率的定義",
      "乘法定理",
      "全概率公式",
      "貝葉斯定理",
      "事件的獨立性"
    ]
  },
  {
    id: 'M21_03',
    name: "重複試驗",
    description: "多次進行相同的隨機試驗",
    order: 3,
    subTopics: [
      "二項分布",
      "幾何分布",
      "負二項分布",
      "超幾何分布",
      "泊松分布"
    ]
  },
  {
    id: 'M21_04',
    name: "組合概率",
    description: "使用組合數學計算複雜事件的概率",
    order: 4,
    subTopics: [
      "排列組合在概率中的應用",
      "多項式定理",
      "容斥原理",
      "鴿籠原理",
      "遞推關係"
    ]
  },
  {
    id: 'M21_05',
    name: "幾何概率",
    description: "在幾何圖形中計算概率問題",
    order: 5,
    subTopics: [
      "長度型幾何概率",
      "面積型幾何概率",
      "體積型幾何概率",
      "隨機投點問題",
      "蒙特卡羅方法"
    ]
  }
];

// 導出模組統計信息
export const M21_STATS = {
  totalTopics: M21_TOPICS.length,
  totalSubTopics: M21_TOPICS.reduce((sum, topic) => sum + topic.subTopics.length, 0),
  estimatedHours: 10,
  difficultyLevel: 2, // 1-3 scale
  prerequisiteModules: 2
}; 